export function get_client_local_time(): {
  timestamp: string;
  timezone: string;
  timezone_offset_minutes: number;
} {
  return {
    timestamp: new Date().toISOString(),
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    timezone_offset_minutes: new Date().getTimezoneOffset() * -1,
  };
}

export function getHumanReadableTimestamp(
  latestAt: string,
  style: "de-DE" | "en-US" = "de-DE",
): string {
  const date = new Date(latestAt);
  const timezoneOffset = date.getTimezoneOffset();
  date.setMinutes(date.getMinutes() - timezoneOffset);

  return date.toLocaleString(style, {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });
}
